module.exports = __webpack_public_path__ + "static/img/unit9.4a27a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unit9.png
// module id = uLM3
// module chunks = 1